function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "var(--primary-color, #000)",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("g", {
  strokeWidth: 1.519
}, /*#__PURE__*/React.createElement("path", {
  d: "M8.649 21.5H39.35v26H8.649z",
  transform: "matrix(-.77466 0 0 .55951 34.746 24.281)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.606 28.5h10.787v19H18.606zM24 .5c-3.09 2.625-19.5 21-19.5 21h39S27.089 3.125 24 .5z",
  transform: "matrix(-.77466 0 0 .55951 34.746 24.281)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M32.999 2.881v7.025c1.011 1.101 1.86 2.011 2.844 3.094L36 11.881v-9z",
  transform: "matrix(-.77466 0 0 .55951 34.746 24.281)"
})), /*#__PURE__*/React.createElement("path", {
  d: "M28.13 36.397h24.001v14.401H28.13z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M31.26 40H49v10.693H31.26zM18.425 25.962H49l6.261 10.435h-3.13"
}));

var SvgSuburbanhome = function SvgSuburbanhome(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSuburbanhome, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Suburban home.7787902c.svg";
export { ForwardRef as ReactComponent };